<div class="cb-form-controls" [ngClass]="'cb-direction-'+layout()">
    <ng-content select="cb-button"></ng-content>
</div>